import axios from 'axios';
import BaseApi from './base';
import {
    GET_RECALLS,
} from '@/constants/api';

export default class extends BaseApi {
    static get() {
        return axios.get(GET_RECALLS);
    }
}